export default __webpack_public_path__ + "static/media/blue_flag.1bf78dac.svg";